import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { map } from 'lodash/fp';
import classnames from 'classnames';

import SectionTitle from '../../PracticeInfo/SectionTitle/index';
import DoctorImage from './DoctorImage/index';
import styles from './ourTeam.module.css';
import { doctorPropType } from '../../../propTypes/index';
import { go } from '../../../../routes/index';

const OurTeam = ({
  title = 'Our Doctors',
  className,
  team,
  onBookNow,
  orgId,
  goToDoctorProfile,
}) => (
  <div className={classnames(styles.container, className)}>
    <SectionTitle title={title} className={styles.sectionTitle} />
    <div className={styles.doctorContainer}>
      <div className={styles.space}>s</div>
      {team
        ? map(
            ({ Name, Picture, PmsUserId, Type }) => (
              <DoctorImage
                name={Name}
                src={Picture}
                type={Type}
                key={PmsUserId}
                onBookNow={onBookNow}
                onImageClick={goToDoctorProfile(orgId, PmsUserId)}
              />
            ),
            team,
          )
        : null}
      <div className={styles.endSpace}>s</div>
    </div>
  </div>
);

OurTeam.propTypes = {
  team: PropTypes.arrayOf(doctorPropType.isRequired),
  goToDoctorProfile: PropTypes.func.isRequired,
  onBookNow: PropTypes.func.isRequired,
  className: PropTypes.string,
  orgId: PropTypes.string,
  title: PropTypes.string,
};

const mapDispatchToProps = dispatch => ({
  // eslint-disable-next-line max-len
  goToDoctorProfile: (orgId, id) => () => go.doctorProfile(orgId, id),
});

export default connect(
  null,
  mapDispatchToProps,
)(OurTeam);
